import {useArrowDownPress, useArrowUpPress, useClickOutside} from 'lib/customHooks';
import {getWordBreakClassName} from 'lib/stringHelper';
import {ExecutionStatus} from 'constants/dataEnum';
import PropTypes from 'prop-types';
import {useRef} from 'react';

import Spinner from 'components/Spinner/Spinner';
import TaskNumber from 'contents/ProtocolEditor/Components/TaskNumber';
import TaskAction from 'contents/ProtocolEditor/TaskList/Task/Components/TaskAction';
import TaskWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskWrapper';
import getTaskTitle from './NormalizationTasksHelper';

function NormalizationPlateSelectionTask({
  number,
  runtimeMode,
  executionStatus,
  onEdit,
  showEditButton,
  onSelectTask,
  isHighlighted,
  onArrowUpPress,
  onArrowDownPress,
  plate,
}) {
  const taskRef = useRef();
  const onClickOutside = () => {
    if (isHighlighted) {
      onSelectTask();
    }
  };
  useClickOutside(taskRef, onClickOutside);
  useArrowUpPress(taskRef, onArrowUpPress);
  useArrowDownPress(taskRef, onArrowDownPress);
  return (
    <TaskWrapper disableDrag isSelected={isHighlighted} ref={taskRef} onClick={onSelectTask}>
      <div>
        <TaskNumber number={number} isHighlighted={isHighlighted} />
      </div>
      <div className="task-description">
        <span className="bold">{getTaskTitle(number)}</span>
        &nbsp;
        <span>from</span>
        &nbsp;
        <span className={`green ${getWordBreakClassName(plate, 19)}`}>{plate}</span>
        <br />
      </div>
      {!runtimeMode && showEditButton && <TaskAction onEdit={() => onEdit(number)} />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTING && <Spinner />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTED && (
        <img className="executed" src="./svg/protocol-editor/execution-done.svg" alt="Executed" />
      )}
    </TaskWrapper>
  );
}
NormalizationPlateSelectionTask.propTypes = {
  runtimeMode: PropTypes.bool,
  executionStatus: PropTypes.string,
  onEdit: PropTypes.func.isRequired,
  showEditButton: PropTypes.bool.isRequired,
  number: PropTypes.number.isRequired,
  onSelectTask: PropTypes.func.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  onArrowUpPress: PropTypes.func.isRequired,
  onArrowDownPress: PropTypes.func.isRequired,
  plate: PropTypes.string.isRequired,
};

NormalizationPlateSelectionTask.defaultProps = {
  runtimeMode: false,
  executionStatus: '',
};
export default NormalizationPlateSelectionTask;
